import { useEffect, useRef } from 'react'
import PageTitle from '../components/PageTitle'
import SubTitle from '../components/SubTitle'
import SEO from '../components/SEO'
import './Contacts.css'

const MAP_CENTER = { lat: 37.57939762542011, lng: 126.88979047165647 }
const KAKAO_PLACE_ID = '575747563'

export default function Contacts() {
  const mapContainerRef = useRef(null)

  useEffect(() => {
    const initMap = () => {
      if (!window.kakao?.maps || !mapContainerRef.current) return

      const { kakao } = window
      const position = new kakao.maps.LatLng(MAP_CENTER.lat, MAP_CENTER.lng)

      const options = {
        center: position,
        level: 3,
      }
      const map = new kakao.maps.Map(mapContainerRef.current, options)

      // 마커 생성
      const marker = new kakao.maps.Marker({ position })
      marker.setMap(map)

      // 마커 클릭 시 다음 지도 페이지로 이동
      kakao.maps.event.addListener(marker, 'click', () => {
        window.open(`https://map.kakao.com/link/map/${KAKAO_PLACE_ID}`, '_blank')
      })

      // 인포윈도우에 씨피엔터테인먼트 표시 (클릭 시 다음 지도로 이동)
      const mapUrl = `https://map.kakao.com/link/map/${KAKAO_PLACE_ID}`
      const iwContent = `<a href="${mapUrl}" target="_blank" rel="noopener noreferrer" style="padding:8px 12px;font-size:14px;font-weight:600;white-space:nowrap;color:black;text-decoration:none;display:block;cursor:pointer;">씨피엔터테인먼트</a>`
      const infowindow = new kakao.maps.InfoWindow({ content: iwContent })
      infowindow.open(map, marker)
    }

    if (window.kakao?.maps) {
      initMap()
      return
    }

    const timer = setInterval(() => {
      if (window.kakao?.maps) {
        initMap()
        clearInterval(timer)
      }
    }, 50)

    return () => clearInterval(timer)
  }, [])

  const subtitleItems = [
    { label: '섭외/제작 문의', value: 'management@cpent.com' },
    { label: '제보 및 신고', value: 'report@cpent.com' },
    { label: '주소', value: '서울특별시 마포구 월드컵북로 396 비즈니스타워, 13층 (상암동, 누리꿈스퀘어)' }
  ]

  return (
    <main className="bg-white">
      <SEO 
        title="연락처"
        description="씨피엔터테인먼트 연락처 및 오시는 길 안내입니다. 섭외 및 제작 문의: management@cpent.com. 서울특별시 마포구 상암동 누리꿈스퀘어 위치."
        path="/contacts"
        keywords="cpent 연락처, 씨피엔터테인먼트 위치, CP Entertainment contact, 섭외 문의, 제작 문의, cpentertainment 주소, 상암동 엔터테인먼트"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "ContactPage",
          "mainEntity": {
            "@type": "Organization",
            "name": "CP Entertainment",
            "email": "management@cpent.com",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "월드컵북로 396 비즈니스타워 13층",
              "addressLocality": "마포구",
              "addressRegion": "서울특별시",
              "postalCode": "03925",
              "addressCountry": "KR"
            }
          }
        }}
      />
      {/* Page Title */}
      <PageTitle title="Contact" />
      <SubTitle items={subtitleItems} />
      
      <section className="max-w-[1280px] mx-auto px-4 md:px-8 py-10 pt-4 md:pt-8">
        <div className="max-w-[1216px] mx-auto space-y-8">
          
          {/* 카카오맵 */}
          <div className="w-full overflow-hidden" role="region" aria-label="오시는 길 지도">
            <div
              ref={mapContainerRef}
              id="kakao-map"
              className="kakao-map-container"
            />
          </div>
        </div>
      </section>
    </main>
  )
}